<template>
      <div>
          <div v-if="centralInfo" class="pt-4" >
            <AlertQueryString :from="current" :unitAvail="centralInfo.unitAvail" :type="centralInfo.type" />
          </div>
          <div v-if="current === 'Register'">
            <Register v-on:changePage="setNextPage" />
          </div>
          <div v-else-if="current === 'Dashboard'">
            <Dashboard v-on:changePage="setNextPage" />
          </div>
          <div v-else-if="current === 'ApplicationsProcess'">
            <ApplicationsProcess v-on:changePage="setNextPage" />
          </div>
          <div v-else-if="current === 'EndorserProcess'">
            <EndorserProcess v-on:changePage="setNextPage" />
          </div>
          <div v-else-if="current === 'UpdateApplicantForm'">
            <step-1 v-on:changePage="setNextPage" btnNextStep="false" from="applicant" />
          </div>
          <div v-else-if="current === 'MissingDoc'">
            <step-3 v-on:changePage="setNextPage" btnNextStep="false" from="missingDoc"/>
          </div>
          <div v-else-if="current === 'ForgetPassword'">
            <ForgetPassword v-on:changePage="setNextPage" />
          </div>
          <div v-else-if="current === 'PasswordChange'">
            <PasswordChange v-on:changePage="setNextPage" />
          </div>
          <div v-else-if="current === 'MessageCenter'">
            <MessageCenter v-on:changePage="setNextPage" />
          </div>
          <div v-else>
            <Login v-on:changePage="setNextPage" />
          </div>
      </div>
</template>

<script>
//import axios from 'axios';
import Login from './Login.vue'
import Register from './Register.vue'
import Dashboard from './Dashboard.vue'
import ApplicationsProcess from './ApplicationsProcess.vue'
import EndorserProcess from './EndorserProcess.vue'
import ForgetPassword from './ForgetPassword.vue'
import PasswordChange from './PasswordChange.vue'
import MessageCenter from './MessageCenter.vue'
import Step1 from './Step1.vue'
import Step3 from './Step3.vue'
import AlertQueryString from './AlertQueryString.vue'

export default {
  name: 'dispatch',
  props: {
    current: {
      type: String,
      default: 'Login'
    }
  },
  mounted () {},
  computed: {
    centralInfo: function () {
      return this.$store.getters.getNoUnitAvailableFromQuery;
    }
  },
  methods: {
    setNextPage(page) {      
      this.$emit('changePage', page);        
    }
  },
  components: {
      Login,
      Register,
      ApplicationsProcess,
      Dashboard,
      ForgetPassword,
      PasswordChange,
      MessageCenter,
      EndorserProcess,
      Step1,
      Step3,
      AlertQueryString
    }
  }
</script>
